export const FORM_MESSAGE = {
  REQUIRED: (field: string) => `${field} is required`,
  INVALID_EMAIL_ADDRESS: 'Invalid email address',
  API_DEFAULT_ERROR_MESSAGE: [
    'Oops, something went wrong, please try again later.',
  ],
  API_DEFAULT_SUCCESS_MESSAGE: [
    'Thanks for getting in touch. One of our team members will reach out to you shortly.',
  ],
};

export const FORM_WHITELIST_KEYS = [
  'submit_to',
  'submit_method',
  'additional_field',
];
